import { PlansPersonaApiFactory } from '@eloomi/eloomi-billing-persona-client/1.0';
import { authorizeClient } from '@/api/authorize-client';

const plansClient = authorizeClient(PlansPersonaApiFactory);

export function getSubscriptionPlans() {
    return plansClient.getPlans();
}
